import React, { useEffect, useState } from 'react';
import { Checkbox, Form, Input, Spin } from 'antd';
import { GetIBWalletDetailsApi, WithdrawIBCommissionApi, GetIBWalletRequestListApi } from '../../../../api/request/ib/ibWallet';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import ConfirmationModal from '../../../../components/modals/ConfirmationModal.jsx';
import Pagination from '../../../../components/pagination/Pagination.jsx';
import TableWithSkeleton from '../../../../components/table/TableWithSkeleton.jsx';
import columns from '../../../../columns/ibwallet.jsx';
import moment from 'moment/moment.js';

export default function Withdraw() {

    const [form] = Form.useForm();
    const [isWalletLoading, setIsWalletLoading] = useState(false);
    const [isWithdrawLoading, setIsWithdrawLoading] = useState(false);
    const [wallet, setWallet] = useState({});
    const [initialValues, setInitialValues] = useState({ amount: '', conditions: false });
    const [withdrawValues, setWithdrawValue] = useState(null);
    const [isOpenWithdrawConfirmationModal, setIsOpenWithdrawConfirmationModal] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecord, setTotalRecord] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setDataAll] = useState([]);
    const [sorter, setSorter] = useState({ SortBy: 'requestDate', SortOrder: '' });

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter?.order) {
            setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
        } else {
            setSorter({ SortBy: 'requestDate', SortOrder: '' });
        }
    };

    const getWalletDetails = async () => {
        try {
            setIsWalletLoading(true);
            const { data } = await GetIBWalletDetailsApi();
            if (data?.success) {
                setWallet(data?.data);
            }
            setIsWalletLoading(false);
        } catch (error) {
            setIsWalletLoading(false);
        }
    }

    const withdrawHandler = async () => {
        try {
            setIsWithdrawLoading(true);
            const { data } = await WithdrawIBCommissionApi(withdrawValues);
            if (data?.success) {
                setInitialValues({ amount: '' });
                toast.success(data?.message);
                form.resetFields();
                getWalletDetails();
                getIbWalletRequests();
                setIsOpenWithdrawConfirmationModal(false);
            }
            setIsWithdrawLoading(false);
        } catch (error) {
            if (error?.response?.data?.message) {
                toast.error(error?.response?.data?.message);
            }
            setIsWithdrawLoading(false);
        }
    }

    const handleSubmit = async (values) => {
        const params = {
            amount: Number(values?.amount),
        };
        setWithdrawValue(params);
        setIsOpenWithdrawConfirmationModal(true);
    }

    const getIbWalletRequests = async () => {
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                ...sorter
            }
            setIsLoading(true);
            const { data: res } = await GetIBWalletRequestListApi(new URLSearchParams(params)?.toString());
            if (res?.success) {
                setDataAll(
                    res?.data?.map((item) => {
                        return {
                            ...item,
                            name: `${item?.firstName} ${item?.lastName}`,
                            requestDate: item?.requestDate ? moment(item?.requestDate).format('DD-MM-YYYY LT') : null,
                            amount: `$ ${item?.amount}`
                        };
                    })
                );
                setTotalRecord(res?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getIbWalletRequests()
    }, [page, pageSize, sorter]);

    useEffect(() => {
        getWalletDetails();
    }, []);

    return (
        <div>
            <div className='border-2 border-light rounded-xl px-4 py-6'>
                {
                    isWalletLoading ? (
                        <div className="flex justify-center flex-col my-2">
                            <Spin size="large" />
                            <p className="primary text-center mt-2">Loading...</p>
                        </div>
                    ) : (
                        <div className='grid md:grid-cols-1 gap-5 md:divide-x border-light'>
                            <div className='grid sm:grid-cols-5 gap-5 sm:divide-x border-light'>
                                <div>
                                    <div className='flex justify-center'><p className='text-base font-normal text-center border-primary'>Generate Commission</p></div>
                                    <p className='text-xl primary font-semibold text-center mt-2'>$ {wallet?.ibCommisionGenerate || 0}</p>
                                </div>
                                <div>
                                    <div className='flex justify-center'><p className='text-base font-normal text-center border-primary'>Available Commission</p></div>
                                    <p className='text-xl primary font-semibold text-center mt-2'>$ {wallet?.ibWalletAmount || 0}</p>
                                </div>
                                <div>
                                    <div className='flex justify-center'><p className='text-base font-normal text-center border-primary'>Withdraw Commission</p></div>
                                    <p className='text-xl primary font-semibold text-center mt-2'>$ {wallet?.ibCommisionWithdraw || 0}</p>
                                </div>
                                <div>
                                    <div className='flex justify-center'><p className='text-base font-normal text-center border-primary'>Minimum Transfer</p></div>
                                    <p className='text-xl primary font-semibold text-center mt-2'>$ {wallet?.min || 0}</p>  
                                </div>
                                <div>
                                    <div className='flex justify-center'><p className='text-base font-normal text-center border-primary'>Maximum Transfer</p></div>
                                    <p className='text-xl primary font-semibold text-center mt-2'>$ {wallet?.max || 0}</p>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>

            <div className='border-[2px] border-light rounded-xl pt-4 lg:pt-6 w-full mt-5'>
                <p className='text-[#2F2B3D] text-xl font-semibold px-4 lg:px-6 pb-4 border-b border-light'>Withdraw</p>

                <Form className='w-full' autoComplete="off" form={form} initialValues={initialValues} onFinish={handleSubmit}>
                    <div className='p-4'>
                        <div className="md:w-1/3">
                            <label className='text-lg text-[#2F2B3DCC] font-medium'>Amount In USD</label>
                            <Form.Item
                                name='amount'
                                rules={[
                                    { required: true, message: 'Please enter amount.' },
                                    {
                                        validator: (_, value) => {
                                            if (!value) {
                                                return Promise.resolve();
                                            }
                                            const amount = Number(value);
                                            if (!Number.isInteger(amount)) {
                                                return Promise.reject(new Error('Please enter a valid amount.'));
                                            }
                                            if (amount < wallet?.minimum) {
                                                return Promise.reject(new Error(`Amount must be at least $${wallet?.minimum}.`));
                                            }
                                            if (amount > wallet?.maximum) {
                                                return Promise.reject(new Error(`Amount cannot exceed $${wallet?.maximum}.`));
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <Input type='number' placeholder="Amount in USD" className="mt-1 w-full ps-4 py-2" />
                            </Form.Item>
                        </div>

                        <div className='flex flex-wrap justify-between items-center'>
                            <Form.Item name='conditions' valuePropName="checked" rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')), }]} >
                                <Checkbox className='mt-4'>Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300' >Terms and conditions</Link></Checkbox>
                            </Form.Item>
                            <div className="mt-4">
                                <button type='submit' className='bg-primary text-sm text-white font-semibold rounded-lg px-8 py-2 uppercase themeHover duration-500'>Submit</button>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>

            {/* Withdraw confirmation modal */}
            <ConfirmationModal
                isOpen={isOpenWithdrawConfirmationModal}
                setIsOpen={setIsOpenWithdrawConfirmationModal}
                type="success"
                message="Are you sure you want to proceed this withdraw request?"
                onConfirm={withdrawHandler}
                isLoading={isWithdrawLoading}
                loadingLabel="Adding request..."
            />

                <div className='border border-gray-200 rounded-xl overflow-hidden bg-white my-6'>
                   <TableWithSkeleton columns={columns} data={data} loading={isLoading} onChange={handleTableChange} />
                </div>
                <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
        </div>
    )
}